import React from "react";
import Dropdown from 'react-bootstrap/Dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faUser } from '@fortawesome/free-solid-svg-icons';
// import { faGear } from '@fortawesome/free-solid-svg-icons';
import { faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from "../../contexts/AuthContext"; 

function TopNav() {
  const { logout, userDetail } = useAuth();
  return (
    <div className="top-bar">
      <div className="dropdown float-end">
        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic">
          {userDetail.name?.replace(/\b\w/g, char => char.toUpperCase())}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={logout}><FontAwesomeIcon className="px-2" icon={faArrowRightFromBracket} />Logout</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
}

export default TopNav;
